var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 72,
    viewBox: "0 0 81 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.956%",
    y1: "131.719%",
    x2: "49.956%",
    y2: "6.753%",
    id: "ualgsl249a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8AB5A0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7AED2",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.967%",
    y1: "-2.301%",
    x2: "49.967%",
    y2: "101.074%",
    id: "2nccmcgyqb"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0F5",
    offset: "99.64%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.711%",
    y1: "53.489%",
    x2: "47.948%",
    y2: "46.545%",
    id: "5qyfweb9fc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D8E4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1E4F0",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.968%",
    y1: "-2.316%",
    x2: "49.968%",
    y2: "101.076%",
    id: "ay38pxp2mf"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0F5",
    offset: "99.64%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-60.2%",
    y: "-68.8%",
    width: "220.3%",
    height: "292.5%",
    filterUnits: "objectBoundingBox",
    id: "2aox3u8jmd"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 11,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77 27v33.558c-.067 1.92-.947 3.565-2.3 4.73C73.55 66.313 71.994 67 70.303 67H17.33c-1.15 0-2.232-.276-3.18-.822a4.491 4.491 0 0 1-1.15-.822l3.383-2.055L42.97 47.41l.88-.546.812-.478 28.82-17.332L77 27z",
    id: "1kzfjap0de"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 72C63.655 72 80 55.892 80 36S63.655 0 43.5 0 7 16.108 7 36s16.345 36 36.5 36z",
    fill: "#D1EEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5 19c1.381 0 2.5-1.116 2.5-2.5 0-1.378-1.119-2.5-2.5-2.5-1.38 0-2.5 1.122-2.5 2.5 0 1.384 1.12 2.5 2.5 2.5z",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 11c1.104 0 2-.893 2-2s-.896-2-2-2c-1.105 0-2 .893-2 2s.895 2 2 2zM7 16c1.104 0 2-.893 2-2s-.896-2-2-2c-1.105 0-2 .893-2 2s.895 2 2 2z",
    fill: "#D1EEDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 54a3.001 3.001 0 0 0 0-6 3 3 0 0 0 0 6z",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 27.208v33.384c-.069 1.91-.958 3.546-2.327 4.705C73.509 66.317 71.935 67 70.224 67H16.638c-1.163 0-2.258-.275-3.216-.818a4.553 4.553 0 0 1-1.164-.818c-.753-.616-1.437-1.501-1.78-2.453-.273-.684-.478-1.434-.478-2.179V27.208s2.805-2.38 6.844-5.652c4.174-3.473 9.649-7.97 14.44-11.926 2.737-2.313 2.463-2.044 6.706-5.584a8.626 8.626 0 0 1 11.156 0c.821.684 1.71 1.501 2.532 2.179 1.78 1.434 3.695 3.07 5.749 4.773 4.311 3.54 9.034 7.494 12.73 10.558 3.763 3.064 6.5 5.383 6.843 5.652z",
    fill: "#5DC389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 20.78v11.773l-11.604 6.971-3.46 2.098-7.33 4.401-3.461 2.098-1.493.879-1.425-.88-3.258-2.097-6.99-4.401-3.257-2.098L17 32.825V20.846c4.14-3.45 9.569-7.918 14.319-11.846l25.991 1.285c4.343 3.59 9.025 7.445 12.69 10.494z",
    fill: "#18A957"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 11.985v21.03l-10.517 6.39-3.1 1.928-6.675 3.983-3.101 1.927-1.348.757-1.281-.757-2.967-1.927-6.337-3.983-2.966-1.927L19 33.225v-21.24a3.964 3.964 0 0 1 3.978-3.983h40.045C65.18 7.934 67 9.787 67 11.985z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 27 32.045 2.141L76 27l-1.295 6.15S42.795 50 43 50c.205 0-32.932-19.962-32.932-19.962L10 27z",
    fill: "url(#ualgsl249a)",
    fillRule: "nonzero",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 27v33.558c-.069 1.92-.958 3.565-2.327 4.73C73.509 66.313 71.935 67 70.224 67H16.638c-1.163 0-2.258-.276-3.216-.822a4.553 4.553 0 0 1-1.164-.822c-.753-.62-1.437-1.51-1.78-2.466-.273-.688-.478-1.442-.478-2.19V27l29.975 18.767 2.601 1.644.89-.546.82-.478L77 27z",
    fill: "#738DFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 65.288C72.85 66.313 71.294 67 69.603 67h-53.04c-1.151 0-2.233-.276-3.18-.822a4.501 4.501 0 0 1-1.15-.822c-.745-.62-1.422-1.51-1.76-2.466-.27-.688-.473-1.442-.473-2.19V27l3.45 2.123 29.632 17.742.812.479.068.067 26.588 15.89L74 65.288z",
    fill: "url(#2nccmcgyqb)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 46.227v2.32L12.96 66a4.58 4.58 0 0 1-1.17-.818c-.758-.617-1.446-1.502-1.79-2.455L40.215 45l2.615 1.637.344.14.826-.55z",
    fill: "url(#5qyfweb9fc)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "m10 27 33 20"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#2aox3u8jmd)",
    xlinkHref: "#1kzfjap0de"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#ay38pxp2mf)",
    xlinkHref: "#1kzfjap0de"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M77 27 44.662 46.167l-.812.548-.88.542L13 65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.211 50H50.78c-.425 0-.78-.224-.78-.498 0-.273.355-.502.78-.502H69.21c.426 0 .78.229.78.502.071.274-.283.498-.78.498zM69.211 56H50.78c-.425 0-.78-.228-.78-.5s.355-.5.78-.5H69.21c.426 0 .78.228.78.5.071.272-.283.5-.78.5z",
    fill: "#5DC389"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73 66 2-1c-.062.067-.062.067-.125.128h-.063L73 66z",
    fill: "#526DFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.836 34c-.526 0-1.02-.196-1.422-.617l-6.834-7.155c-.773-.812-.773-2.169 0-2.981a1.975 1.975 0 0 1 2.845 0l5.41 5.67 12.74-13.308a1.964 1.964 0 0 1 2.845 0c.773.807.773 2.17 0 2.976L43.258 33.383c-.371.421-.897.617-1.422.617z",
    fill: "#5DC389"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.36a7dedddd7d95de35cbb86e41631c84.svg";
export { ForwardRef as ReactComponent };